import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=4c87d635"
import script from "./skills.vue?vue&type=script&lang=js"
export * from "./skills.vue?vue&type=script&lang=js"
import style0 from "./skills.vue?vue&type=style&index=0&id=4c87d635&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports